var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1319,
    height: 1007,
    viewBox: "0 0 1319 1007",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1496.76 470.851C1508.87 748.015 1183.84 987.333 770.775 1005.38C357.712 1023.43 13.0398 813.377 0.92883 536.212C-11.1821 259.048 313.854 19.7301 726.917 1.68088C1139.98 -16.3683 1484.65 193.686 1496.76 470.851Z",
    fill: "url(#paint0_radial_2687_2023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2687_2023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(350.764 128.712) rotate(87.498) scale(502.329 748.631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4213D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4213D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGradient);
export default __webpack_public_path__ + "static/media/hero-gradient.a4d9268392ad669a5792443acb720c17.svg";
export { ForwardRef as ReactComponent };